export const urlRoutes = {
  landingPage: "/",
  loanRequestForm: "/loan-request",
  profilePage: "/profile",
  loanDetailPage: "/loan-detail",
  loggedInLandingLoansList: "/loans-list",
  signupPage: "/signup",
  loginPage: "/login",
  portfolioPage: "/portfolio",
  existingLoanDetail: "/existing-loan-detail",
};

export const loanStatus = {
  REQUESTED: "REQUESTED",
  EXPIRED: "EXPIRED",
  ACTIVE: "ACTIVE",
  COMPLETED: "COMPLETED",
  DISABLED: "DISABLED",
};
